import {
  GET_BUTTON_REPAIR_CIT_EXECUTOR_CASH_DELIVERY,
  GET_SEAL_LIST_CIT_EXECUTOR_CASH_DELIVERY,
  GET_BUTTON_ACCEPT_CIT_EXECUTOR_CASH_DELIVERY,
  GET_FINAL_SEAL_CIT_EXECUTOR_CASH_DELIVERY,
} from 'shared/constants/ActionTypes';

const initialState = {
  buttonRepair: true,
  buttonAccept: true,
  sealNoList: [],
  finalSeal: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BUTTON_REPAIR_CIT_EXECUTOR_CASH_DELIVERY:
      return {
        ...state,
        buttonRepair: action.payload,
      };
    case GET_SEAL_LIST_CIT_EXECUTOR_CASH_DELIVERY:
      return {
        ...state,
        sealNoList: action.payload,
      };
    case GET_BUTTON_ACCEPT_CIT_EXECUTOR_CASH_DELIVERY:
      return {
        ...state,
        buttonAccept: action.payload,
      };
    case GET_FINAL_SEAL_CIT_EXECUTOR_CASH_DELIVERY:
      return {
        ...state,
        finalSeal: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
